import React from 'react';
import {
  Box, IconButton,
} from '@mui/material';
import { observer } from 'mobx-react';
import { Signup } from '@gamiphy/loyalty-station-desktop/components/cashback';
import Close from '@mui/icons-material/Close';
import { CashbackPopupsStore } from '@gamiphy/loyalty-station-desktop/store/cashbackPopups';

const SignupScreen: React.FC<{
  afterSignup: () => void,
}> = ({
  afterSignup,
}) => (
  <Box p={2} maxWidth={350}>
    <Box pb="1.6rem" display="flex" justifyContent="flex-end">
      <IconButton sx={{ ml: 'auto', p: 0 }} disableRipple onClick={() => CashbackPopupsStore.closeCashbackPopup()}>
        <Close fontSize="large" />
      </IconButton>
    </Box>
    <Signup onDone={afterSignup} />
  </Box>
);

export default observer(SignupScreen);
